import React from "react";

export const PeintureIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none">
      <path
        d="M15.4531 13.3897V11.4688C14.8463 11.7346 14.4219 12.3452 14.4219 13.0367V13.3897C14.4219 14.2427 13.7279 14.9366 12.875 14.9366C12.0221 14.9366 11.3281 14.2427 11.3281 13.3897V11.8312L8.45486 18.011C7.85521 19.277 6.56602 20.0929 5.16889 20.0929C4.80428 20.0929 4.44815 20.0376 4.10938 19.9347V22.119C4.19706 22.2348 4.65729 22.542 5.95025 22.8071C7.14409 23.0518 8.68775 23.1866 10.2969 23.1866C11.906 23.1866 13.4497 23.0518 14.6435 22.8071C15.9365 22.542 16.3967 22.2348 16.4844 22.119V13.9054H15.9688C15.684 13.9054 15.4531 13.6745 15.4531 13.3897Z"
        fill="#BF2C53"
      />
      <path
        d="M2.99565 17.8928C3.02211 17.9329 3.04986 17.9717 3.07804 18.01V14.7305L2.7763 15.4346C2.42539 16.2532 2.50533 17.1492 2.99565 17.8928Z"
        fill="#BF2C53"
      />
      <path
        d="M7.52137 17.5726L11.1503 9.76744C10.8691 9.77552 10.5845 9.78009 10.2969 9.78009C8.46853 9.78009 6.74409 9.61449 5.44112 9.31381C5.42812 9.3108 5.41563 9.30771 5.40274 9.30469L4.10938 12.3226V18.8408C4.43491 18.9845 4.79291 19.0613 5.16889 19.0613C6.16955 19.0613 7.09298 18.477 7.52137 17.5726Z"
        fill="#BF2C53"
      />
      <path
        d="M12.3594 9.70922V13.3919C12.3594 13.6762 12.5907 13.9075 12.875 13.9075C13.1593 13.9075 13.3906 13.6762 13.3906 13.3919V13.0389C13.3906 11.7579 14.2514 10.6838 15.4531 10.3826V10.2982C15.4531 10.0134 15.684 9.78255 15.9688 9.78255H16.4844V8.89062C16.1322 9.05091 15.6891 9.19247 15.1526 9.31627C14.3553 9.50027 13.3996 9.63339 12.3594 9.70922Z"
        fill="#BF2C53"
      />
      <path
        d="M10.2963 8.75C11.9055 8.75 13.4491 8.61521 14.643 8.37045C15.8177 8.12961 16.3051 7.85398 16.4501 7.71875C16.3051 7.58352 15.8177 7.30789 14.643 7.06705C13.4491 6.82229 11.9055 6.6875 10.2963 6.6875C8.68722 6.6875 7.14355 6.82229 5.94972 7.06705C4.77496 7.30789 4.2876 7.58352 4.14258 7.71875C4.2876 7.85398 4.77496 8.12961 5.94972 8.37045C7.14355 8.61521 8.68722 8.75 10.2963 8.75Z"
        fill="#BF2C53"
      />
      <path
        d="M4.10938 8.89062V9.70698L4.40657 9.01351C4.30105 8.97386 4.20219 8.93287 4.10938 8.89062Z"
        fill="#BF2C53"
      />
      <path
        d="M29.8906 20.0938C29.6063 20.0938 29.375 20.3251 29.375 20.6094V25.7656C29.375 26.0499 29.6063 26.2812 29.8906 26.2812C30.1749 26.2812 30.4062 26.0499 30.4062 25.7656V20.6094C30.4062 20.3251 30.1749 20.0938 29.8906 20.0938Z"
        fill="#BF2C53"
      />
      <path
        d="M16.4844 10.8125H28.8594V12.875H16.4844V10.8125Z"
        fill="#BF2C53"
      />
      <path
        d="M22.1562 18.5469H23.1875V20.0938H22.1562V18.5469Z"
        fill="#BF2C53"
      />
      <path
        d="M22.1562 26.2539V27.3111H23.1875V26.2798H22.4866C22.3743 26.2798 22.2641 26.2707 22.1562 26.2539Z"
        fill="#BF2C53"
      />
      <path
        d="M25.7159 20.2571L24.7997 19.3409C24.6418 19.183 24.4382 19.0874 24.2188 19.0664V20.6089C24.2188 20.8937 23.9879 21.1245 23.7031 21.1245H19.9614C19.7501 21.1245 19.5781 21.2965 19.5781 21.5078C19.5781 21.6731 19.6835 21.8192 19.8403 21.8715L20.7725 22.1822C20.9536 22.2426 21.0866 22.3982 21.118 22.5866L21.4098 24.3372C21.4979 24.8659 21.9507 25.2495 22.4866 25.2495H28.3437V21.1245H27.8099C27.0189 21.1245 26.2753 20.8165 25.7159 20.2571Z"
        fill="#BF2C53"
      />
      <path
        d="M32.4688 13.6484C32.4688 14.9278 31.4278 15.9688 30.1484 15.9688H24.4972C23.7747 15.9688 23.1875 16.5559 23.1875 17.2784V17.5156H22.1562V17.2784C22.1562 15.9874 23.2062 14.9375 24.4972 14.9375H30.1484C30.8594 14.9375 31.4375 14.3594 31.4375 13.6484C31.4375 12.9375 30.8594 12.3594 30.1484 12.3594H29.8906V11.3281H30.1484C31.4278 11.3281 32.4688 12.369 32.4688 13.6484Z"
        fill="#BF2C53"
      />
    </svg>
  );
};
